<sfc-toast *ngIf="toastMessage" disappear-after="2000" [type]=toastMessage.type animate-from="bottom" >{{toastMessage.message}}</sfc-toast>
